export class PopUpYnet extends React.Component<{ onClose: () => void, loading: boolean }, {}> {
    public render() {
        const { loading } = this.props;
        if (loading) {
            return (
                <div className="redMailPopUp">
                    <div className="loading"></div>
                    <p className="title">עוד רגע מסיימים...</p>
                </div>
            )
        } else {
            return (
                <div className="redMailPopUp">
                    <div className="finish"></div>
                    <p className="title">תודה שדיווחתם!</p>
                    <p className="subTitle">המידע התקבל ונשלח לבדיקה</p>
                    <button className="popUpButton"><a href="/">חזרה לדף הבית</a></button>
                </div>
            )
        }
    }

}



